import { React, useEffect, useState } from 'libs/react';
import { FormMediaPicker } from 'components/media/form/FormMediaPicker';
import { LazyReactQuill } from 'components/form/LazyReactQuill';
import { useDealConfiguratorContext } from 'modules/deal/DealConfigureScreen';
import { FormRadioList } from 'components/form/FormRadioList';
import { FormInput } from 'components/form/FormInput';
import { Text } from 'components/Text';
import './DealPresentationSection.scss';
/**
 * @component DealPresentationSection
 * @since 1.0.0
 */
export function DealPresentationSection(props) {
    const { type, defaultMedia, defaultMediaType, infos, media, mediaType, text, medias } = props;
    const { updateDealField } = useDealConfiguratorContext();
    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline'],
            [{ align: [] }]
        ]
    };
    const [textValue, setTextValue] = useState(text !== null && text !== void 0 ? text : '');
    const [mediaTypeValue, setMediaType] = useState(mediaType);
    const [mediaValue, setMediaValue] = useState(media !== null && media !== void 0 ? media : '');
    useEffect(() => {
        setTextValue(text !== null && text !== void 0 ? text : '');
        setMediaValue(media !== null && media !== void 0 ? media : '');
        setMediaType(mediaType);
    }, [text, media, mediaType]);
    /**
     * @function onMediaTypeChange
     * @since 1.0.0
     */
    const onMediaTypeChange = (value) => {
        setMediaType(value);
        if (value === 'default') {
            updateDealField('medias', medias === null || medias === void 0 ? void 0 : medias.filter((m) => m.type !== type + '_IMAGE' && m.type !== type + '_VIDEO'), 'object');
            setMediaValue(defaultMedia !== null && defaultMedia !== void 0 ? defaultMedia : '');
            return;
        }
        if (value === 'image') {
            updateDealField('medias', medias === null || medias === void 0 ? void 0 : medias.filter((m) => m.type !== type + '_VIDEO'), 'object');
        }
        else if (value === 'video') {
            updateDealField('medias', medias === null || medias === void 0 ? void 0 : medias.filter((m) => m.type !== type + '_IMAGE'), 'object');
        }
        setMediaValue('');
    };
    return (React.createElement("div", { className: "deal-presentation-section" },
        React.createElement("div", { className: "deal-presentation-section-title" },
            React.createElement(Text, { className: "deal-presentation-section-title--subtitle", value: infos })),
        React.createElement("div", { className: "deal-presentation-section-content" },
            React.createElement("div", { className: "deal-presentation-section-container" },
                React.createElement(FormRadioList, { name: type + '_MEDIA_TYPE', value: mediaTypeValue, onChange: (value) => onMediaTypeChange(value), options: [
                        { label: t('Default'), value: 'default' },
                        { label: t('Image'), value: 'image' },
                        { label: t('Video'), value: 'video' }
                    ] }),
                mediaTypeValue === 'default' && (React.createElement("div", { className: "deal-presentation-section-default" },
                    React.createElement(Text, { className: "deal-presentation-section-default-message", value: t('The default value from settings will be used.') }),
                    defaultMediaType === 'image' && defaultMedia && (React.createElement("div", { className: "deal-presentation-section-default-preview" },
                        React.createElement("img", { src: defaultMedia, alt: t('Default image'), className: "deal-presentation-section-default-image" }))),
                    defaultMediaType === 'video' && mediaValue && (React.createElement("div", { className: "deal-presentation-section-default-preview" },
                        React.createElement(Text, { className: "deal-presentation-section-default-link", value: mediaValue }))))),
                mediaTypeValue === 'image' && (React.createElement(FormMediaPicker, { name: type + '_IMAGE', style: "extended", types: "image/*", onMediaPickerPick: (media) => {
                        var _a;
                        const mediaId = Array.isArray(media) && media.length > 0
                            ? media[0].id
                            : !Array.isArray(media) && media
                                ? media.id
                                : null;
                        // replace or add the media to the medias array
                        const tempMedias = (_a = medias === null || medias === void 0 ? void 0 : medias.filter((m) => m.type !== type + '_IMAGE')) !== null && _a !== void 0 ? _a : [];
                        const updatedMedias = [
                            ...tempMedias,
                            {
                                media: {
                                    id: mediaId
                                },
                                type: type + '_IMAGE'
                            }
                        ];
                        updateDealField('medias', updatedMedias, 'object');
                        setMediaValue(mediaId !== null && mediaId !== void 0 ? mediaId : '');
                    }, value: mediaValue, editable: true })),
                mediaTypeValue === 'video' && (React.createElement(FormInput, { name: type + '_VIDEO', value: mediaValue, onChange: (value) => {
                        var _a;
                        const tempMedias = (_a = medias === null || medias === void 0 ? void 0 : medias.filter((m) => m.type !== type + '_VIDEO')) !== null && _a !== void 0 ? _a : [];
                        const updatedMedias = [
                            ...tempMedias,
                            {
                                url: value,
                                type: type + '_VIDEO'
                            }
                        ];
                        updateDealField('medias', updatedMedias, 'object');
                        setMediaValue(value);
                    }, placeholder: t('Enter the video URL') }))),
            React.createElement("div", { className: "deal-presentation-section-container" },
                React.createElement(LazyReactQuill, { theme: "snow", modules: modules, defaultValue: textValue, onChange: (value) => {
                        const normalized = value
                            .replace(/&nbsp;/g, ' ')
                            .replace(/\u00A0/g, ' ');
                        if (type === 'INTRODUCTION') {
                            updateDealField('introduction', normalized, 'string');
                        }
                        else {
                            updateDealField('headline', normalized, 'string');
                        }
                    } })))));
}
